import getStoryHref from '../../utils/getStoryHref'

export default getStoryHref
